import { RootState } from '@/types/common';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TeacherState } from '@/types/teacher-dashboard';
import { ClassOverviewData } from '@/types/progress';

const initialState: TeacherState = {
  students: [],
};

const teacher = createSlice({
  name: 'teacher',
  initialState,
  reducers: {
    setStudents: (state, { payload }: PayloadAction<ClassOverviewData[]>) => {
      state.students = payload;
    },
  },
});

export const teacherActions = teacher.actions;

export const teacherSelector = (state: RootState) => state.teacher;

export default teacher.reducer;
